import apiClient from './apiClient'

/**
 * Submits the two onboarding survey answers (user type, referral source). The backend appends them
 * to a CSV on disk — there is no DB column — and fills the identity columns (userId/email/username)
 * from the access token, so this body carries only the survey fields. Goes through `apiClient`, so the
 * bearer token + refresh are handled automatically.
 *
 * Designed to be non-blocking for the flow: returns `true` on success and `false` on failure rather
 * than throwing, so a survey hiccup never stops onboarding.
 *
 * @param {{userType:string,userTypeOther:string,referralSource:string,referralSourceOther:string}} body
 * @returns {Promise<boolean>}
 */
export async function submitSurvey(body) {
    try {
        await apiClient.post('/v1/onboarding/survey', body)
        return true
    } catch (err) {
        console.error('Onboarding survey submit failed', err)
        return false
    }
}
